exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat[data-v-0204e464]{height:400px}", ""]);

// exports
